export default __webpack_public_path__ + "static/media/slider3.e2a270bc.png";